import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const DebouncedInput = ({ state, setState, label, name, delay = 500 }) => {
  const [inputValue, setInputValue] = useState(state ?? "");
  const { t } = useTranslation();

  // mark when a prop-sync happened so debounced effect ignores it
  const ignoreNextRef = useRef(false);
  // mark when user typed so debounced effect knows it's user-initiated
  const userChangedRef = useRef(false);

  // sync incoming prop -> local input but mark it as prop-driven
  useEffect(() => {
    const incoming = state ?? "";
    if (incoming !== inputValue) {
      ignoreNextRef.current = true;
      userChangedRef.current = false;
      setInputValue(incoming);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // debounced callback: only call parent when user changed the value
  useEffect(() => {
    const handler = setTimeout(() => {
      if (ignoreNextRef.current) {
        ignoreNextRef.current = false;
        return;
      }
      if (userChangedRef.current) {
        setState(name, inputValue === "" ? null : inputValue);
        userChangedRef.current = false;
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [inputValue, name, setState, delay, state]);

  const onChange = (e) => {
    userChangedRef.current = true;
    setInputValue(e.target.value);
  };

  return (
    <input
      type="text"
      className="text-input-sm"
      value={inputValue}
      name={label}
      onChange={onChange}
      placeholder={t(`yard-tables.table-columns.${label}`)}
    />
  );
};

export default DebouncedInput;
